export default __webpack_public_path__ + "static/media/boletoIcon.dc434b84.svg";